class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
// Auto-fill checkout with wellness quiz data
(function() {
  function setupCheckoutAutoFill() {
    const checkoutData = localStorage.getItem('wellnessCheckoutData');
    if (!checkoutData) return;
    
    try {
      const userData = JSON.parse(checkoutData);
      
      // Build checkout URL with pre-filled data
      const checkoutUrl = `/checkout?` +
        `checkout[email]=${encodeURIComponent(userData.email)}` +
        `&checkout[shipping_address][first_name]=${encodeURIComponent(userData.firstName)}` +
        `&checkout[shipping_address][last_name]=${encodeURIComponent(userData.lastName)}` +
        `&checkout[shipping_address][phone]=${encodeURIComponent(userData.phone)}`;
      
      // Find checkout button/link in drawer
      const findAndUpdateCheckoutButton = () => {
        const checkoutButtons = document.querySelectorAll(
          '#CartDrawer a[href="/checkout"], ' +
          '#CartDrawer button[name="checkout"], ' +
          '#CartDrawer a[href*="/checkouts"], ' +
          '#CartDrawer form[action="/cart"] button[type="submit"], ' +
          '.cart-drawer__footer a[href="/checkout"], ' +
          '.cart__checkout-button'
        );
        
        checkoutButtons.forEach(btn => {
          // Remove existing listeners by cloning
          const newBtn = btn.cloneNode(true);
          btn.parentNode.replaceChild(newBtn, btn);
          
          newBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('✅ Redirecting to checkout with auto-fill');
            window.location.href = checkoutUrl;
          });
        });
        
        if (checkoutButtons.length > 0) {
          console.log(`✅ Auto-fill enabled for ${checkoutButtons.length} checkout button(s)`);
        }
      };
      
      // Run immediately
      findAndUpdateCheckoutButton();
      
      // Also run when cart drawer opens/updates
      const observer = new MutationObserver(() => {
        findAndUpdateCheckoutButton();
      });
      
      const cartDrawer = document.querySelector('#CartDrawer');
      if (cartDrawer) {
        observer.observe(cartDrawer, { childList: true, subtree: true });
      }
      
    } catch(e) {
      console.error('Error setting up checkout auto-fill:', e);
    }
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCheckoutAutoFill);
  } else {
    setupCheckoutAutoFill();
  }
  
  // Re-run when cart drawer content changes
  document.addEventListener('cart:updated', setupCheckoutAutoFill);
})();